import OverlayScrollbars from "overlayscrollbars";
require('jquery-watch');

export let timeline = {};

let currentEle;
let currentEleBar;
let currentFontSize;
let showMoreStatus = false;
let startIndex = 0;
let numIndex = 8;
let lastIndex = numIndex;
let allowScroll = 0;
let allowScroll2 = 0;
let scrollDirection = 'down';
let wasStop = false;
let wasStop2 = false;
let counter = 0;
let counter2 = 0;

timeline.init = () => {
  currentFontSize = timeline.getComputedStyle('year-container', 'line-height');
  timeline.setId('timeline-bar-item', 'fortl');
  timeline.setId('year-container', 'year');
  timeline.viewportEvent('timeline-card');
  timeline.hider('timeline-card');
  timeline.hider('timeline-bar-item');
  timeline.initialSetter('timeline-card');
  timeline.observer();
  timeline.viewerSetHeight();

  OverlayScrollbars(document.getElementById('js-scrollbar'), {
    scrollbars: {
      "visibility": "hidden",
      "dragScrolling": true,
      "touchSupport": true,
    },
    callbacks: {
      onScroll() {
        // timeline.forceScroll();
      },
      onScrollStop() {
        timeline.viewportEvent('timeline-card');
        timeline.checkingLast('timeline-card');
      }
    },
  });

  timeline.showContent('js-btn-show', 'timeline-card');

  if (window.innerWidth < 979) {
    timeline.setHeightMobile();
  }

  if (window.innerWidth < 1025) {
    if (document.body.classList.contains('ipad')) {
      timeline.setHeightMobile();
    }
  }

  // Controls the scrolling inside the section
  // $('.js-scrollbar').on('wheel', function (e) {

  //   if (e.originalEvent.wheelDeltaY < 0) {

  //     if (e.originalEvent.wheelDeltaY < -125) {
  //       fullpage_api.setAllowScrolling(true);
  //     }

  //     OverlayScrollbars(document.getElementById('js-scrollbar')).scroll({
  //       y: "+=100"
  //     });
  //   }

  //   if (e.originalEvent.wheelDeltaY > 0) {

  //     if (e.originalEvent.wheelDeltaY > 125) {
  //       fullpage_api.setAllowScrolling(true);
  //     }

  //     OverlayScrollbars(document.getElementById('js-scrollbar')).scroll({
  //       y: "-=100"
  //     });
  //   }

  // });



  if(document.body.classList.contains('firefox')) {
    document.getElementsByClassName('js-scrollbar')[0].addEventListener('DOMMouseScroll', function(e) {
      // console.log(e);
      if(e.detail <= -3) {
        scrollDirection = 'up';
      // if (e.originalEvent.wheelDeltaY > 125) {
      //   fullpage_api.setAllowScrolling(true);
      // }
      // console.log('here2');

      // console.log(scrollDirection);
      // console.log(allowScroll2);
      // console.log(wasStop2);
        if (scrollDirection == 'up') {
          if (allowScroll2 == 1) {
            if (wasStop2) {
              // setTimeout(function() {
              //   fullpage_api.moveSectionUp();
              //   fullpage_api.setAllowScrolling(true);
              //   console.log('moving asdasdoUpn');
              // }, 100);

              counter2++;
              if (counter2 > 1 && counter2 < 20) {
                // fullpage_api.moveSectionUp();
                fullpage_api.moveTo(3);
                fullpage_api.setAllowScrolling(true);
              }
            }
          }
        }
      }

      if(e.detail > -3) {
        scrollDirection = 'down';
      // if (e.originalEvent.wheelDeltaY < -125) {
      //   fullpage_api.setAllowScrolling(true);
      // }

      // console.log('here');
      // console.log(scrollDirection);
      // console.log(allowScroll);
      // console.log(wasStop);

        if (scrollDirection == 'down') {
          if (allowScroll == 1) {
            if (wasStop) {
              counter++;
              // console.log(counter);
              if (counter > 1 && counter < 20) {
                fullpage_api.moveTo(5);
                fullpage_api.setAllowScrolling(true);
              }
            }
          }
        }
      }
    });
  } else if(document.body.classList.contains('msie')) {

    $('.js-scrollbar').on('DOMMouseScroll mousewheel wheel', function (e) {
      // console.log(e);
      if(e.originalEvent.deltaY < 0) {
        scrollDirection = 'up';
      // if (e.originalEvent.wheelDeltaY > 125) {
      //   fullpage_api.setAllowScrolling(true);
      // }
      // console.log('here2');

      // console.log(scrollDirection);
      // console.log(allowScroll2);
      // console.log(wasStop2);
        if (scrollDirection == 'up') {
          if (allowScroll2 == 1) {
            if (wasStop2) {
              // setTimeout(function() {
              //   fullpage_api.moveSectionUp();
              //   fullpage_api.setAllowScrolling(true);
              //   console.log('moving asdasdoUpn');
              // }, 100);

              counter2++;
              if (counter2 > 1 && counter2 < 20) {
                // fullpage_api.moveSectionUp();
                fullpage_api.moveTo(3);
                fullpage_api.setAllowScrolling(true);
              }
            }
          }
        }
      }

      if(e.originalEvent.deltaY > 0) {
        scrollDirection = 'down';
      // if (e.originalEvent.wheelDeltaY < -125) {
      //   fullpage_api.setAllowScrolling(true);
      // }

      // console.log('here');
      // console.log(scrollDirection);
      // console.log(allowScroll);
      // console.log(wasStop);

        if (scrollDirection == 'down') {
          if (allowScroll == 1) {
            if (wasStop) {
              counter++;
              // console.log(counter);
              if (counter > 1 && counter < 20) {
                fullpage_api.moveTo(5);
                fullpage_api.setAllowScrolling(true);
              }
            }
          }
        }
      }
    });
  } else {
    $('.js-scrollbar').on('wheel', function (e) {
      // console.log(e.originalEvent.deltaY);
      if (e.originalEvent.wheelDeltaY < 0) {
        scrollDirection = 'down';
        // console.log('was down');
        // if (e.originalEvent.wheelDeltaY < -125) {
        //   fullpage_api.setAllowScrolling(true);
        // }

        // console.log('here');
        // console.log(scrollDirection);
        // console.log(allowScroll);
        // console.log(wasStop);

        if (scrollDirection == 'down') {
          if (allowScroll == 1) {
            if (wasStop) {
              counter++;
              // console.log(counter);
              if (counter > 1 && counter < 20) {
                fullpage_api.moveTo(5);
                fullpage_api.setAllowScrolling(true);
              }
            }
          }
        }
      }

      if (e.originalEvent.wheelDeltaY > 0) {
        scrollDirection = 'up';
        // if (e.originalEvent.wheelDeltaY > 125) {
        //   fullpage_api.setAllowScrolling(true);
        // }
        // console.log('here2');

        // console.log(scrollDirection);
        // console.log(allowScroll2);
        // console.log(wasStop2);
        if (scrollDirection == 'up') {
          if (allowScroll2 == 1) {
            if (wasStop2) {
              // setTimeout(function() {
              //   fullpage_api.moveSectionUp();
              //   fullpage_api.setAllowScrolling(true);
              //   console.log('moving asdasdoUpn');
              // }, 100);

              counter2++;
              if (counter2 > 1 && counter2 < 20) {
                // fullpage_api.moveSectionUp();
                fullpage_api.moveTo(3);
                fullpage_api.setAllowScrolling(true);
              }
            }
          }
        }
      }

    });
  }



  // fullpage_api.setAllowScrolling(true);

}


timeline.checkingLast = (e) => {
  let ele = document.getElementsByClassName(e);
  if (!ele) return;

  for (let i = 0; i < ele.length; i++) {
    if (!ele[i].classList.contains('is-hidden')) {

      if (i == ele.length - 1) {
        numIndex = ele[i].id.replace('tl', '');
      }

      if (ele[i].classList.contains('is-active')) {
        if (currentEle == ele[i].id) {
          if (numIndex == ele[i].id.replace('tl', '')) {
            allowScroll = 1;
            wasStop = true;
            scrollDirection = 'down';
            fullpage_api.setAllowScrolling(true);
          } else {
            fullpage_api.setAllowScrolling(false);
            allowScroll = 0;
            wasStop = false;
            counter = 0;
          }

          if (startIndex == ele[i].id.replace('tl', '')) {
            allowScroll2 = 1;
            scrollDirection = 'up';
            fullpage_api.setAllowScrolling(true);
            wasStop2 = true;
          } else {
            fullpage_api.setAllowScrolling(false);
            allowScroll2 = 0;
            wasStop2 = false;
            counter2 = 0;
          }
        }
      }
    }

    if (i > 10000) break;
  }
}

timeline.getComputedStyle = (e, styleProp) => {
  let el = document.getElementsByClassName(e)[0];
  if (!el) return;
  let camelize = function (str) {
    return str.replace(/\-(\w)/g, function (str, letter) {
      return letter.toUpperCase();
    });
  };

  if (el.currentStyle) {
    return el.currentStyle[camelize(styleProp)];
  } else if (document.defaultView && document.defaultView.getComputedStyle) {
    return document.defaultView.getComputedStyle(el, null)
      .getPropertyValue(styleProp);
  } else {
    return el.style[camelize(styleProp)];
  }
}

timeline.setId = (e, name) => {
  let ele = document.getElementsByClassName(e);
  if (!ele) return;

  for (let i = 0; i < ele.length; i++) {
    ele[i].id = name + i;
    if (name == 'year') {
      ele[i].style.height = currentFontSize;
    }
  }
}

timeline.initialSetter = (e) => {
  let ele = document.getElementsByClassName(e);
  if (!ele) return;

  for (let i = 0; i < ele.length; i++) {

    if (!ele[i].classList.contains('is-hidden')) {
      if (ele[i].classList.contains('is-active')) {
        currentEle = ele[i].id;
        // ele[i].classList.add('is-active');
        document.getElementById('for' + ele[i].id).classList.add('is-active');
        currentEleBar = 'for' + ele[i].id;
        timeline.getCurrentYear(ele[i]);
        timeline.relativeTimeBar(currentEle);
        timeline.checker('timeline-card', currentEle);
        timeline.checker('timeline-bar-item', currentEleBar);
      }
    }
  }
}

timeline.viewportEvent = (e, bol) => {
  let ele = document.getElementsByClassName(e);
  if (!ele) return;

  for (let i = 0; i < ele.length; i++) {
    ele[i].id = "tl" + i;
    // console.log(timeline.viewportDetector(ele[i], 'js-scrollbar'));

    if (!ele[i].classList.contains('is-hidden')) {

      if (timeline.viewportDetector(ele[i], 'js-vd')) {
        if (!ele[i].classList.contains('is-active')) {
          currentEle = ele[i].id;
          ele[i].classList.add('is-active');
          document.getElementById('for' + ele[i].id).classList.add('is-active');
          currentEleBar = 'for' + ele[i].id;
          timeline.getCurrentYear(ele[i]);
          timeline.relativeTimeBar(currentEle);
          timeline.checker('timeline-card', currentEle);
          timeline.checker('timeline-bar-item', currentEleBar);
          fullpage_api.setAllowScrolling(false);
          counter = 0;
          // console.log(fullpage_api);
        }
      }
    }
  }
}

timeline.relativeTimeBar = (e) => {
  let removedString = currentEle.replace('tl', '');
  let parsedString = parseInt(removedString);
  let ele = document.getElementsByClassName('timeline-bar-item');
  let isMiddle = (ele.length > 17) ? true : false;

  if (showMoreStatus) {
    // let temptIndex = lastIndex + numIndex;
    // let finalIndex = lastIndex;
    // console.log("parsedString: " + parsedString);
    // console.log("lastIndex: " + lastIndex);
    // if(parsedString < lastIndex) {
    //   temptIndex = lastIndex + numIndex;
    //   console.log(">>> " + temptIndex);
    // } else {
    //   temptIndex = lastIndex - numIndex;
    //   console.log(">> " + temptIndex);
    // }


    for (let i = 0; i < ele.length; i++) {

      if (parsedString <= 8) {
        if (i > 8) {
          ele[i].classList.add('is-hidden');
          trailDotsFirst.style.display = "none";
        } else {
          ele[i].classList.remove('is-hidden');
          traitDotSecond.style.display = "block";
        }

        startIndex = 0;
      }

      if (parsedString > 8) {
        if (i > 8 && i <= 17) {
          ele[i].classList.remove('is-hidden');
          trailDotsFirst.style.display = "block";
        } else {
          ele[i].classList.add('is-hidden');
          traitDotSecond.style.display = "none";
        }

        startIndex = 8;

        if (isMiddle) {
          traitDotSecond.style.display = "block";
          trailDotsFirst.style.display = "block";
        }
      }

      if (parsedString > 17) {
        if (i > 17 && i <= 27) {
          ele[i].classList.remove('is-hidden');
          trailDotsFirst.style.display = "block";
          traitDotSecond.style.display = "none";
        } else {
          ele[i].classList.add('is-hidden');
          traitDotSecond.style.display = "none";
        }

        startIndex = 17;
      }

      // if(parsedString > 16 && i < 26) {
      //   if (i < 17) {
      //     ele[i].classList.add('is-hidden');
      //     trailDotsFirst.style.display = "block";
      //   } else {
      //     ele[i].classList.remove('is-hidden');
      //     traitDotSecond.style.display = "none";
      //   }
      // }


      // if (i > lastIndex && i < temptIndex) {
      //   finalIndex = i;
      //   ele[i].classList.remove('is-hidden');
      // } else {
      //   ele[i].classList.add('is-hidden');
      // }

    }

    // if (finalIndex === parsedString) {
    //   lastIndex = finalIndex;
    // }
  }
}

timeline.checker = (e, curr) => {
  let ele = document.getElementsByClassName(e);
  if (!ele) return;

  for (let i = 0; i < ele.length; i++) {
    if (ele[i].id !== curr) {
      ele[i].classList.remove('is-active');
    }

    if (i > 10000) break;
  }
}

timeline.getCurrentYear = (e) => {
  let childArr = e.children;
  for (let i = 0; i < childArr.length; i++) {
    if (childArr[i].classList.contains('timeline-title')) {
      timeline.setData(childArr[i], e);
    }
  }
}

timeline.setData = (e, parent) => {
  // let cleanTxt = e.innerText.replace(/ +/g, "") || e.textContent.replace(/ +/g, "");
  let cleanTxt = e.dataset.year;
  let finalTxt = cleanTxt.split('');
  timeline.setTime(parent.dataset.yearLength, finalTxt);
  // console.log(finalTxt);
}

timeline.setTime = (e, fintxt) => {
  let iter;
  let eNum = 5;
  let wasFour = false;
  currentFontSize = currentFontSize.replace('px', '');

  if (e == 5) {
    iter = 0;
  } else {
    iter = 1;
  }

  for (let i = iter; i < eNum; i++) {
    if (e == 4) {
      if (i == 4 || i == 3) {
        document.getElementById('year' + i).children[0].style.transform = "translate(0, -" + ((parseInt(fintxt[i - 1]) + 1) * currentFontSize) + "px)";
      } else {
        document.getElementById('year' + i).children[0].style.transform = "translate(0, -" + ((parseInt(fintxt[i - 1])) * currentFontSize) + "px)";
      }

      let num = document.getElementById('year0').children[0].children.length;
      document.getElementById('year0').children[0].style.transform = "translate(0, -" + (num * currentFontSize) + "px)";
      wasFour = true;
    } else {
      if (i == 4 || i == 3) {
        if (!wasFour) {
          if (i == 3) {
            document.getElementById('year' + i).children[0].style.transform = "translate(0, -" + (fintxt[i - 1] * currentFontSize) + "px)";
          }
          if (i == 4) {
            document.getElementById('year' + i).children[0].style.transform = "translate(0, -" + (fintxt[i - 2] * currentFontSize) + "px)";
          }
        }
      } else {
        document.getElementById('year' + i).children[0].style.transform = "translate(0, -" + (fintxt[i] * currentFontSize) + "px)";
      }
    }
  }
}

timeline.viewportDetector = (e, pEle) => {
  let bounding = e.getBoundingClientRect();
  let heiLM;
  let heiDM;
  // console.log(pEle);

  if (window.innerWidth > 1775) {
    heiLM = Math.floor(document.getElementById(pEle).offsetHeight / 4);
    heiDM = Math.floor(document.getElementById(pEle).offsetHeight / 2);
  }

  if (window.innerWidth > 1499) {
    heiLM = Math.floor(document.getElementById(pEle).offsetHeight / 3);
    heiDM = Math.floor(document.getElementById(pEle).offsetHeight / 2);
  }

  if (window.innerWidth < 1080) {
    heiLM = Math.floor(document.getElementById(pEle).offsetHeight / 3.5);
    heiDM = Math.floor(document.getElementById(pEle).offsetHeight / 5);
  }

  // console.log(document.getElementById(pEle).offsetHeight);

  // console.log(bounding.top);
  if (bounding.top < document.getElementById(pEle).offsetHeight) {
    // console.log(e);
    return true
  }

  // if (document.getElementById(pEle).offsetHeight < bounding.top && bounding.top < document.getElementById(pEle).offsetHeight) {
  //   return true
  // }

  // if(bounding.top >= 0 &&
  // bounding.left >= 0 &&
  // bounding.bottom <= (window.innerHeight || document.getElementById(pEle).clientHeight) &&
  // bounding.right <= (window.innerWidth || document.getElementById(pEle).clientWidth)) {
  //   console.log('tae');
  // }
}

timeline.hider = (e, btn) => {
  let ele = document.getElementsByClassName(e);
  if (ele.length > 8) {
    for (let i = 0; i < ele.length; i++) {
      if (i > 8) {
        ele[i].classList.add('is-hidden');
      }
    }
  }
}

timeline.show = (e) => {
  let ele = document.getElementsByClassName(e);
  if (ele.length > 8) {
    for (let i = 0; i < ele.length; i++) {
      if (i > 8) {
        if (ele[i].classList.contains('is-hidden')) {
          ele[i].classList.remove('is-hidden');
        }
      }
    }
  }
}

timeline.showContent = (btn, e) => {
  let ele = document.getElementsByClassName(btn);

  for (let i = 0; i < ele.length; i++) {
    ele[i].addEventListener('click', function () {
      timeline.show(e);
      timeline.barShow('timeline-bar-item');
      this.style.display = "none";
      showMoreStatus = true;
    });
  }
}

timeline.barShow = (e) => {
  let ele = document.getElementsByClassName(e);
  let isMiddle = (ele.length > 17) ? true : false;

  if (ele.length > 8) {
    for (let i = 0; i < ele.length; i++) {
      if (i > 8 && i <= 17) {
        if (ele[i].classList.contains('is-hidden')) {
          ele[i].classList.remove('is-hidden');
          traitDotSecond.style.display = "none";
        }

        if (isMiddle) {
          traitDotSecond.style.display = "block";
          // traitDotSecond.style.display = "none";
        }
      }

      if (i <= 8) {
        ele[i].classList.add('is-hidden');
        trailDotsFirst.style.display = "block";
      }
    }
  }

  // let temptIndex = lastIndex + numIndex;
  // let finalIndex = lastIndex;
  // for (let i = 0; i < ele.length; i++) {
  //   if (i >= lastIndex && i < temptIndex) {
  //     finalIndex = i;
  //     ele[i].classList.remove('is-hidden');
  //     traitDotSecond.style.display = "block";
  //   } else {
  //     ele[i].classList.add('is-hidden');
  //     trailDotsFirst.style.display = "none";
  //   }
  // }

  // lastIndex = finalIndex;
}

timeline.setHeightMobile = () => {
  let mediaHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  let ele = document.getElementsByClassName('js-mobile-timeline');
  if (!ele) return;
  for (let i = 0; i < ele.length; i++) {
    // ele[i].style.maxHeight = mediaHeight + "px";
    // ele[i].style.overflowY = "auto";
  }

  timeline.hideMobile('js-timeline-card-mobile');
  timeline.showContentMobile('js-btn-show-mobile', 'js-timeline-card-mobile');
}

timeline.hideMobile = (e) => {
  let ele = document.getElementsByClassName(e);
  if (ele.length > 5) {
    for (let i = 0; i < ele.length; i++) {
      if (i > 4) {
        ele[i].classList.add('is-hidden');
      }
    }
  }
}

timeline.showMobile = (e) => {
  let ele = document.getElementsByClassName(e);
  if (ele.length > 5) {
    for (let i = 0; i < ele.length; i++) {
      if (i > 4) {
        if (ele[i].classList.contains('is-hidden')) {
          ele[i].classList.remove('is-hidden');
        }
      }
    }
  }
}

timeline.showContentMobile = (btn, e) => {
  let ele = document.getElementsByClassName(btn);

  for (let i = 0; i < ele.length; i++) {
    ele[i].addEventListener('click', function () {
      timeline.showMobile(e);
      this.style.display = "none";
      fullpage_api.reBuild();
    });
  }
}

timeline.observer = () => {
  setTimeout(() => {
    $(".js-section-timeline .fp-scroller").watch({
      // specify CSS styles or attribute names to monitor
      properties: "transform",

      // callback function when a change is detected
      callback: function (data, i) {
        let self, styleString;
        self = $(this);
        styleString = self.attr('style');

        if (styleString.includes('translate(0px, 0px)')) {
          // fullpage_api.moveSectionUp();
          fullpage_api.moveTo(3);
        }
      }
    });
  }, 500);
}

timeline.viewerSetHeight = () => {
  // let me = document.getElementById('tl0').offsetHeight + document.getElementsByClassName('section-title')[0].offsetHeight + timeline.computeMargin(document.getElementById('tl0')) + timeline.computeMargin(document.getElementsByClassName('section-title')[0]);

  let initialCompute = document.getElementById('tl0').offsetHeight + document.getElementsByClassName('section-title')[0].offsetHeight + timeline.computeMargin(document.getElementById('tl0')) + timeline.computeMargin(document.getElementsByClassName('section-title')[0]);
  let finalComp;
  if(document.body.classList.contains('msie')) {
    finalComp = initialCompute - 75;
  } else {
    finalComp = initialCompute;
  }
  document.getElementById('js-vd').style.height = finalComp + "px";
}

timeline.computeMargin = (e) => {
  let comptSyle = window.getComputedStyle(e);
  let comptStyleTop = Number(comptSyle.marginTop.replace('px', ''));
  let comptStyleBottom = Number(comptSyle.marginBottom.replace('px', ''));
  let final = comptStyleTop + comptStyleBottom;

  return final;
}



// WEBPACK FOOTER //
// ./scripts/components/featured/history/modules/timeline.js